export const ADD_SKUBASES = "ADD_SKUBASES";
export const ADD_SKUVARIANTS = "ADD_SKUVARIANTS";